export const ShopData = [
  {
    id: 1,
    NameCode: "Taïeb - BR55",
    Code: "BR55",
    Ouverture: "10 Jan 2020",
    Phone: "+71 200 200",
    Adresse: "Taïeb, Tunis",
  },
  {
    id: 2,
    NameCode: "La Marsa - MR15",
    Code: "MR15",
    Ouverture: "01 Juin 2022",
    Phone: "+71 300 300",
    Adresse: "La Marsa, Tunis",
  }
 
];
